import { NgModule } from '@angular/core';
import { MsButtonSpeedDialComponent } from './ms-button-speed-dial.component';
import { SharedLibsModule } from 'app/shared/shared-libs.module';
import { MsButtonModule } from '../ms-button/ms-button.module';

@NgModule({
	declarations: [MsButtonSpeedDialComponent],
	imports: [SharedLibsModule, MsButtonModule],
	exports: [MsButtonSpeedDialComponent],
	providers: [],
})
export class MsButtonSpeedDialModule {}
